<script>
import { mapState } from "pinia";
import { useAppStore } from "@/app-store/app";

export default {
  name: "app-footer",
  computed: {
    ...mapState(useAppStore, ["layoutConfig"]),
    bgClass() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.footer) return "bg-color-first";
      return `bg-color-${layoutConfig.footer.containerColor}`;
    },
    style() {
      const padding = this.layoutConfig?.footer?.padding || 5;
      return `padding: ${padding}px`;
    },
  },
};
</script>

<template>
  <div
    :class="`text-center footer-content ${bgClass}`"
    v-html="layoutConfig?.footer?.content"
    :style="style"
  ></div>
</template>

<style>
.footer-content a {
  @apply font-bold;
}
</style>
